import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '既存のECシステムが転用できない自動車中古部品の専門知識・業務フローを深く理解し、要件定義から開発・現地常駐・運用まで一気通貫で支援。業務自体を変える「真のDX」で、世界90カ国向けグローバルECサイトを構築し売上約130%増を達成した会宝産業の開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/kaiho/ogp_kaiho.png'

export const kaihoPageMeta: PageMeta = {
  title: '売上130%増を実現したグローバルEC構築｜世界90カ国向け自動車部品販売の開発事例 | Aitria（アイトリア）',
  description,
  keyword: 'システム開発 AWS UX/UI 要件定義 ECサイト',
  image: ogpImg,
  url: `${SITE_URL}/cases/kaiho/`,
}

export const kaihoSchema = buildCaseStudySchema({
  slug: 'kaiho',
  pageTitle: kaihoPageMeta.title,
  description: kaihoPageMeta.description,
  headline: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
  alternativeHeadline: '会宝産業株式会社',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/kaiho/top.png'],
  clientName: '会宝産業株式会社',
  breadcrumbLabel: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
})
